import Ukiyo from "ukiyojs";
document.addEventListener("DOMContentLoaded", init);
const parallaxInstances = [];
const parallaxInstancesList = [];

function init() {
  initParallax();
  initParallaxList();
  initParallaxReset();
}

function initParallax() {
  const images = document.querySelectorAll(".paralax-image img");
  images.forEach((image) => {
    const instance = new Ukiyo(image, {
      speed: 1.3,
      scale: 1.5,
      willChange: true,
    });

    parallaxInstances.push(instance);
  });
}



//paralax for tab section

function initParallaxList() {
  const imagesList = document.querySelectorAll(".paralax-image-list img");
  imagesList.forEach((image) => {
    const instance = new Ukiyo(image, {
      speed: 1.3,
      scale: 1.5,
      willChange: true,
    });

    parallaxInstancesList.push(instance);
  });
}

function initParallaxReset() {
  bindEvents();

  function bindEvents() {
    let parallaxImages = document.querySelectorAll(".paralax-image-list");

    let observer = new ResizeObserver((entries) => {
      reset();
    });

    parallaxImages.forEach((parallaxImage) => {
      observer.observe(parallaxImage);
    });
  }

  function reset() {
    parallaxInstancesList.forEach((instance) => {
      instance.reset();
    });
  }
}